export default __webpack_public_path__ + "static/media/phone-pe.1b283849.png";